import { fmtPct, initials } from "../../services/retroFormatters";

function deltaText(delta) {
  if (delta > 0) return `▲ +${delta.toFixed(1)}`;
  if (delta < 0) return `▼ ${delta.toFixed(1)}`;
  return "■ 0.0";
}

export default function TeamMembersTable({ members = [], onOpenMember }) {
  return (
    <div className="page-table-wrap feature-table-wrap">
      <table className="page-table feature-table feature-table--sticky-2 rtv2-team-table">
        <colgroup>
          <col className="c-member" />
          <col className="c-current" />
          <col className="c-target" />
          <col className="c-score" />
          <col className="c-delta" />
          <col className="c-goals" />
          <col className="c-tenure" />
          <col className="c-status" />
          <col className="c-open" />
        </colgroup>
        <thead>
          <tr>
            <th className="sticky-col-1">Member</th>
            <th className="sticky-col-2">Current stage</th>
            <th>Next stage</th>
            <th>Score</th>
            <th>Δ</th>
            <th>Goals</th>
            <th>Tenure</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {members.map((m) => (
            <tr key={m.id} onClick={() => onOpenMember?.(m.id)}>
              <td className="td-member sticky-col-1">
                <div className="rtv2-member-cell">
                  <div className="av">{initials(m.name)}</div>
                  <div className="who"><b>{m.name}</b><span>{m.role}</span></div>
                </div>
              </td>
              <td className="td-current sticky-col-2">{m.current}</td>
              <td className="td-target"><b>{m.target}</b></td>
              <td className="td-score">{m.score.toFixed(1)}/10</td>
              <td className={`td-delta ${m.delta >= 0 ? "up" : "down"}`}>{deltaText(m.delta)}</td>
              <td className="td-goals">
                <div className="rtv2-goal-mini">
                  <span>{fmtPct(m.goalPct)}</span>
                  <i><b style={{ width: fmtPct(m.goalPct) }} /></i>
                </div>
              </td>
              <td className="td-tenure">{m.tenure}</td>
              <td className="td-status"><span className={`rtv2-tt-state ${String(m.status || "").toLowerCase().replace(/\s+/g, "-")}`}>{m.status}</span></td>
              <td className="td-open">›</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
